// src/db/index.js
import Dexie from 'dexie';

class BlueCometDB extends Dexie {
  constructor() {
    super('BlueComet');
    
    // Define database schema
    this.version(1).stores({
      threads: 'id, title, lastUpdated, createdAt, model',
      messages: 'id, threadId, role, timestamp, [threadId+timestamp]'
    });
    
    // Add methods to the database class
    this.threads = this.table('threads');
    this.messages = this.table('messages');
  }
  
  // Helper to get complete thread with messages
  async getCompleteThread(threadId) {
    const thread = await this.threads.get(threadId);
    if (!thread) return null;
    
    const messages = await this.messages
      .where('threadId')
      .equals(threadId)
      .sortBy('timestamp');
    
    return { ...thread, messages };
  }
  
  // Get storage stats
  async getStorageStats() {
    const threadCount = await this.threads.count();
    const messageCount = await this.messages.count();
    
    // Calculate approximate size
    const threadsSize = await this.threads.toArray()
      .then(threads => JSON.stringify(threads).length);
    
    // Sample message size from the most recent 20 messages
    const recentMessages = await this.messages
      .orderBy('timestamp')
      .reverse()
      .limit(20)
      .toArray();
      
    const avgMessageSize = recentMessages.length > 0 ?
      JSON.stringify(recentMessages).length / recentMessages.length : 0;
    
    const estimatedMessagesSize = avgMessageSize * messageCount;
    const totalEstimatedSize = threadsSize + estimatedMessagesSize;
    
    return {
      threadCount,
      messageCount,
      estimatedSizeBytes: totalEstimatedSize,
      estimatedSizeMB: (totalEstimatedSize / (1024 * 1024)).toFixed(2)
    };
  }
}

const db = new BlueCometDB();
export default db;